import React from 'react';
import { BookOpenIcon, BrainIcon, VideoIcon, GraduationCapIcon } from 'lucide-react';
export function HeroSection() {
  return <>
      {/* Banner fino de oferta - atraviesa toda la página */}
      <div className="w-full bg-white py-1.5 px-4 border-t border-b border-[#c41e3a] overflow-hidden" data-id="element-97">
        <div className="animate-scroll-right" data-id="element-98">
          <p className="text-black text-xs md:text-sm font-bold tracking-wide whitespace-nowrap" data-id="element-99">
            💈 OFERTA POR LANZAMIENTO - 60% DE DESCUENTO 💈 OFERTA POR
            LANZAMIENTO - 60% DE DESCUENTO 💈 OFERTA POR LANZAMIENTO - 60% DE
            DESCUENTO
          </p>
        </div>
      </div>

      <section className="w-full bg-[#0a0a0a] py-16 md:py-20 lg:py-24 px-4 relative" data-id="element-100">
        {/* Logo flotante - Barber Pro Academy */}
        <div className="fixed top-6 left-6 z-50" data-id="element-101">
          <img src="https://cdn.magicpatterns.com/uploads/nTBDp8jLQqs428HDhKddZJ/ChatGPT_Image_24_feb_2026,_12_38_15_a.m..png" alt="Barber Pro Academy Logo" className="w-16 h-16 md:w-20 md:h-20 drop-shadow-2xl" data-id="element-102" />
        </div>

        <div className="max-w-7xl mx-auto" data-id="element-103">
          <div className="text-center mb-20" data-id="element-104">
            <h1 className="text-6xl md:text-7xl lg:text-8xl font-black leading-tight text-white mb-8" data-id="element-105">
              Método Barber Pro
            </h1>
            {/* Línea decorativa */}
            <div className="w-32 h-1 bg-[#c41e3a] mx-auto mb-8" data-id="element-106"></div>

            <h2 className="text-3xl md:text-4xl text-gray-300 font-bold mb-10 max-w-4xl mx-auto leading-relaxed" data-id="element-107">
              Formación profesional en barbería basada en un método estructurado
            </h2>
            <p className="text-xl md:text-2xl text-gray-300 leading-relaxed max-w-3xl mx-auto" data-id="element-108">
              Aprendé barbería con criterio real a través de una formación en
              formato{' '}
              <span className="text-white font-bold" data-id="element-109">ebook + videos</span>,
              diseñada para estudiar, consultar y aplicar en la práctica diaria.
            </p>
          </div>

          {/* Imagen principal */}
          <div className="flex justify-center mb-20" data-id="element-110">
            <img src="https://cdn.magicpatterns.com/uploads/xxiNDAdA5WvE8qmHCeXCdE/Gemini_Generated_Image_y45kpy45kpy45kpy.png" alt="Método Barber Pro - Formación profesional en barbería" className="w-full max-w-lg rounded-lg shadow-2xl" data-id="element-111" />
          </div>

          {/* Bullets en cards grandes y rectangulares */}
          <div className="max-w-5xl mx-auto mb-16" data-id="element-112">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-113">
              <div className="flex items-start gap-6 text-gray-200 bg-[#1a1a1a] p-10 rounded-lg border-4 border-gray-700" data-id="element-114">
                <BookOpenIcon className="w-12 h-12 text-[#c41e3a] flex-shrink-0" aria-hidden="true" data-id="element-115" />
                <span className="text-xl font-semibold leading-relaxed" data-id="element-116">
                  Ebooks profesionales descargables
                </span>
              </div>
              <div className="flex items-start gap-6 text-gray-200 bg-[#1a1a1a] p-10 rounded-lg border-4 border-gray-700" data-id="element-117">
                <BrainIcon className="w-12 h-12 text-[#c41e3a] flex-shrink-0" aria-hidden="true" data-id="element-118" />
                <span className="text-xl font-semibold leading-relaxed" data-id="element-119">
                  Método estructurado, no improvisación
                </span>
              </div>
              <div className="flex items-start gap-6 text-gray-200 bg-[#1a1a1a] p-10 rounded-lg border-4 border-gray-700" data-id="element-120">
                <VideoIcon className="w-12 h-12 text-[#c41e3a] flex-shrink-0" aria-hidden="true" data-id="element-121" />
                <span className="text-xl font-semibold leading-relaxed" data-id="element-122">
                  Videos de apoyo incluidos
                </span>
              </div>
              <div className="flex items-start gap-6 text-gray-200 bg-[#1a1a1a] p-10 rounded-lg border-4 border-gray-700" data-id="element-123">
                <GraduationCapIcon className="w-12 h-12 text-[#c41e3a] flex-shrink-0" aria-hidden="true" data-id="element-124" />
                <span className="text-xl font-semibold leading-relaxed" data-id="element-125">
                  Enfoque técnico y profesional
                </span>
              </div>
            </div>
          </div>

          {/* CTA más grande */}
          <div className="flex justify-center" data-id="element-126">
            <button className="bg-[#c41e3a] hover:bg-[#a01830] text-white font-black text-2xl px-16 py-7 rounded-lg transition-colors duration-200 shadow-2xl" aria-label="Acceder a la formación Método Barber Pro" data-id="element-127">
              👉 Acceder a la formación
            </button>
          </div>
        </div>
      </section>
    </>;
}